import { useQuery, UseQueryOptions } from 'react-query'

import { queryClient, useQueryKeyBuilder } from 'data/hooks/_helpers'
import { fetchAndReturn } from 'data/utils/utils'

const LIST_NAME = 'automations/connections'

export function useAutomationConnections(options: UseQueryOptions<AutomationConnectionDto[]> = {}) {
    const queryKey = useQueryKeyBuilder([LIST_NAME], {
        includeAuthKeys: true,
        includeStackId: true,
    })

    return useQuery<AutomationConnectionDto[]>(
        queryKey,
        async () => {
            return fetchAndReturn(`automations/connections/`) as Promise<AutomationConnectionDto[]>
        },
        options
    )
}

export function invalidateAutomationConnections() {
    return queryClient.invalidateQueries(LIST_NAME)
}
